import { AttachmentStatus } from '../enums/attachmentStatus'
import { Attachment } from '../types/attachment'

export const splitAttachmentsByUploadStatus = (attachments: Attachment[]) => {
  const completedAttachments: Attachment[] = []
  const uploadingAttachments: Attachment[] = []

  for (const attachment of attachments) {
    if (attachment.status === AttachmentStatus.Done || attachment.status === AttachmentStatus.Failed) {
      completedAttachments.push(attachment)
    } else if (attachment.status === AttachmentStatus.Uploading) {
      uploadingAttachments.push(attachment)
    }
  }

  return { completedAttachments, uploadingAttachments }
}
